import * as Actions from "../../constants/constants";
import { request } from "../request";

export const fetchDocumentTypeList = () => (dispatch) => {
    return request(`Document/DocumentTypeList`, "GET", {})
        .then((response) => {
            dispatch({
                type: Actions.GET_DOCUMENT_TYPE_LIST_SUCCESS,
                payload: response.Data,
            });

            return Promise.resolve(response.Data)
        })
        .catch((error) => {
            dispatch({
                type: Actions.GET_DOCUMENT_TYPE_LIST_FAIL,
                payload: error
            })
        });
}

export const fetehDocumentTypesList = (userId) => (dispatch) => {
    return request(`Document/DocumentTypesList?id=${userId}`, "GET",)
        .then((response) => {
            dispatch({
                type: Actions.GET_DOCUMENT_TYPES_LIST_SUCCESS,
                payload: response.Data,
            });

            return Promise.resolve(response.Data)
        })
        .catch((error) => {
            dispatch({
                type: Actions.GET_DOCUMENT_TYEPS_LIST_FAIL,
                payload: error
            })
        });
}